<template>
  <div class="callback-container">
    <el-card class="callback-card">
      <el-alert v-if="loading" title="正在授权登录中..." type="info" show-icon></el-alert>
      <el-alert v-else-if="error" title="授权失败" type="error" :description="errorMsg" show-icon></el-alert>
    </el-card>
  </div>
</template>

<script>
import request from '@/utils/request';

export default {
  name: 'Callback',
  data() {
    return {
      loading: true,
      error: false,
      errorMsg: ''
    };
  },
  async created() {
    try {
      // 步骤1：获取URL中的code和state（state是授权前的目标页面）
      const code = this.$route.query.code;
      const targetPath = decodeURIComponent(this.$route.query.state || '/tasks'); // 解析目标页面
      if (!code) throw new Error('授权失败：未获取到code参数');

      // 步骤2：调用后端接口，用code兑换Token和用户信息
      const res = await request({
        url: '/wxwork/auth/callback', 
        method: 'get',
        params: { code }
      });

      // 步骤3：存储登录态（和账号密码登录保持一致）
      if (!res.token || !res.username) throw new Error('后端未返回有效登录信息');
      localStorage.setItem('accessToken', res.token); // 存储Token
      localStorage.setItem('adminName', res.username); // 存储用户名

      // 步骤4：跳转到目标页面（核心！从state取的授权前目标）
      this.$router.push({ path: targetPath, replace: true }); 
      this.$message.success('企业微信授权登录成功！');
    } catch (err) {
      this.loading = false;
      this.error = true;
      this.errorMsg = err.message || '授权登录异常，请重试';
      console.error('授权回调失败：', err);
      // 失败后3秒跳转回登录页
      setTimeout(() => {
        this.$router.push('/login');
      }, 3000);
    } finally {
      this.loading = false;
    }
  }
};
</script>